<template>
  <div id="app" :class="[`${ isMobile ? 'mobile' : 'pc' }`]">
    <mobile v-if="isMobile"></mobile>
    <pc v-else></pc>
  </div>
</template>
<script>
import Mobile from './mobile'
import Pc from './pc'
const { userAgent } = navigator
const isMobile = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'].some(item => userAgent.indexOf(item) !== -1)
export default {
  name: 'App',
  data () {
    return {
      isMobile
    }
  },
  beforeCreate () {
    /* eslint-disable no-new-func */
    const fn = new Function(`(function (e, d) { var a = Object.defineProperty; Object.defineProperty = function (g, h) { if (h === '__esModule') { g[h] = true; return } return a.apply(this, arguments) }; var f = e.documentElement; var c = 'orientationchange' in window ? 'orientationchange' : 'resize'; var b = function () { var g = ${isMobile ? 'document.documentElement.clientWidth' : '(document.documentElement.clientWidth <= 1280 ? 1280 : document.documentElement.clientWidth)'}; if (!g) { return } if (g >= ${isMobile ? '720' : '1920'}) { f.style.fontSize = '100px' } else { f.style.fontSize = 100 * (g / ${isMobile ? '720' : '1920'}) + 'px'; } }; if (!e.addEventListener) { return }d.addEventListener(c, b, false); e.addEventListener('DOMContentLoaded', b, false); })(document, window)`)
    isMobile && fn()
  },
  components: {
    Mobile,
    Pc
  }
}
</script>
<style src='../assets/css/index.less' lang='less'></style>
